'use client'

import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/solid'
import { TargetLanguageCode } from 'deepl-node'
import { parseAsBoolean, useQueryState } from 'nuqs'
import { TargetLanguage } from '../translate/types'

const DisplayNames: Record<string, string> = {
    'English (American)': 'English',
    'Portuguese (Brazilian)': 'Portuguese',
}
type Props = { ordered: TargetLanguageCode[]; langOrder: TargetLanguage[] }
const LangTagsDemo = ({ ordered, langOrder }: Props) => {
    const [langName, setShowLangName] = useQueryState('langName', parseAsBoolean)
    return (
        <div className="flex flex-wrap gap-1 overflow-auto">
            {ordered.map((lang, index) => {
                const isActive = true
                return (
                    <span
                        key={lang}
                        className={`md:text-md btn btn-sm text-sm`}
                        style={{
                            color: isActive ? `var(--skeleton-text-color-${index})` : undefined,
                            backgroundColor: isActive ? `var(--skeleton-color-${index})` : undefined,
                        }}
                        onClick={() => {}}
                    >
                        {langName ? lang : getFullLanguageName()}
                    </span>
                )

                function getFullLanguageName() {
                    const name = langOrder.find((l) => l.code === lang)!.name
                    return DisplayNames[name] || name
                }
            })}
            <button className={`btn btn-primary btn-sm`}>+</button>
            <button
                className={`btn btn-primary btn-sm`}
                onClick={() => {
                    setShowLangName(!langName)
                }}
            >
                {langName ? <ChevronRightIcon height={12} /> : <ChevronLeftIcon height={12} />}
            </button>
        </div>
    )
}

export default LangTagsDemo
